/**
 * Instagram-style stories for leaderboard (unique users, no names)
 */
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import { useLeaderboard } from "../../contexts/LeaderboardContext";

const baseUrl = import.meta.env.VITE_APP_BASE_URL;

const Header = ({ setShouldShowNewHomeUI }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useContext(UserContext);
  const [uniqueStories, setUniqueStories] = useState([]);
  const {
    leaderboard,
    loading: isLoadingLeaderboard,
    error: leaderboardError,
  } = useLeaderboard();

  useEffect(() => {
    if (leaderboard && Array.isArray(leaderboard)) {
      // Filter for unique users by userId
      const seen = new Set();
      const unique = [];
      for (const user of leaderboard) {
        if (user.userId && !seen.has(user.userId)) {
          seen.add(user.userId);
          unique.push(user);
        }
      }
      setUniqueStories(unique);
    } else {
      setUniqueStories([]);
    }
  }, [leaderboard]);

  // useEffect(() => {
  //   console.log(
  //     "[Header] Rendered. userData.profilePhoto:",
  //     userData.profilePhoto
  //   );
  //   console.log("[Header] uniqueStories state:", uniqueStories);
  // });

  const storyBorder =
    "p-1 bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 rounded-full";
  const isTutorPage = location.pathname.includes("/tutor");
  const isDashboardPage = location.pathname.startsWith("/dashboard");
  const isProfilePage = location.pathname.startsWith("/profile-update");
  const isFeedbackPage = location.pathname.startsWith("/feedback");
  const goToProfile = () => {
    navigate("/profile-update");
    setShouldShowNewHomeUI ? setShouldShowNewHomeUI(false) : null;
  };

  if (isTutorPage) {
    console.log("[Header] isTutorPage is true, returning null.");
    return null;
  }

  if (isFeedbackPage) {
    console.log("[Header] isFeedbackPage is true, returning null.");
    return null;
  }

  // Temporarily disable header on Dashboard pages
  // We may re-enable this later; keeping logic simple and reversible
  if (isDashboardPage) {
    return null; // Commenting out header rendering for dashboard
  }

  return (
    <div className="w-full grid grid-cols-6 pointer-events-none mt-2">
      <div className="col-span-4" />
      <div className="col-span-2 flex justify-end pointer-events-auto">
        {/* Stories Row (hidden on dashboard) */}
        {!isDashboardPage && (
          <div
            className={`${
              isProfilePage ? "hidden md:flex" : "flex"
            } items-center gap-2.5 px-4 overflow-x-auto overflow-y-hidden`}
          >
            {/* Right-aligned cluster: Notification Bell + Update Profile */}
            <div className="ml-auto flex items-center gap-3">
              <div className="w-[40px] h-[40px] rounded-full bg-[#0D99FF] flex justify-center items-center text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                  className="w-4 h-4"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
              </div>

              {/* Update Profile story tile */}
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={goToProfile}
              >
                <div className={storyBorder}>
                  <div className="bg-white rounded-full p-1">
                    <img
                      src={
                        userData.profilePhoto ||
                        "/assets/avatars/defaultprofile.png"
                      }
                      alt="Update Profile"
                      className="w-10 h-10 rounded-full object-cover"
                      onError={() =>
                        console.log(
                          "[Header] Error loading your profile photo:",
                          userData.profilePhoto
                        )
                      }
                    />
                  </div>
                </div>
                <span className="mt-1 text-[10px] text-center font-medium">
                  Update Profile
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
